module.exports = __webpack_public_path__ + "static/TT1394_TW-MARK-D02_r1-clean-ec9bf766862c6a5453af12ecd032cd79.png";